export default __webpack_public_path__ + "static/media/document_123.9f79c6cc.svg";